'use client';

import { useRouter } from 'next/navigation';
import { setCookie } from 'nookies';
import { useEffect } from 'react';

import { COOKIE_NAME_DEALERSHIP_ID } from '@/constants/dealership/dealership.constants';
import { setDealershipCookieOnUser } from '@/services/gtm.service';
import type { DealershipProps } from '@/types/dealership/dealership.types';


type Props = {
  dealerInfo: DealershipProps;
};

const DealershipCookie = ({ dealerInfo }: Props) => {
  const router = useRouter();

  useEffect(() => {
    // store this current dealer as the preferred dealer
    setCookie(null, COOKIE_NAME_DEALERSHIP_ID, dealerInfo.id, {
      maxAge: process.env.NEXT_PUBLIC_DEALERSHIP_COOKIE_AGE || 1800,
      path: '/',
      sameSite: true
    });

    setDealershipCookieOnUser();

    router.refresh();
  }, []);

  return null;
};

export default DealershipCookie;
